export default /* glsl */ `uniform float pointSize;

float getPointSize(vec4 xyzw) {
  return pointSize;
}`;
